import { ByteConverter } from '../byteCoverter'

export default class FileRestrictions {
	public static sizeIsGreaterThan(sizeInMB: number, fileSize: number): boolean {
		const fileSizeInMb: number = ByteConverter.bytesToMegabytes(fileSize)
		return fileSizeInMb > sizeInMB
	}
}
